import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "65.768",
  height: "58.328",
  viewBox: "0 0 65.768 58.328"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "”gas-icon-1-clip-path”" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "65.767",
      height: "58.328",
      fill: "none"
    })
  ])
], -1)
const _hoisted_3 = { transform: "translate(0 0)" }
const _hoisted_4 = {
  transform: "translate(0 0)",
  "clip-path": "url(#gas-icon-1-clip-path)"
}
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["fill"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconGas1',
  props: {
  color: {
    type: String,
    default: '#DBDBDB',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("g", _hoisted_3, [
      _createElementVNode("g", _hoisted_4, [
        _createElementVNode("path", {
          d: "M6.311,19.738V47.309H53.357V19.738",
          transform: "translate(3.049 9.536)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_5),
        _createElementVNode("path", {
          d: "M63.8,27.039,32.4,1,1,27.039",
          transform: "translate(0.483 0.484)",
          fill: "none",
          stroke: __props.color,
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2"
        }, null, 8, _hoisted_6),
        _createElementVNode("path", {
          d: "M29.936,22.891a2.778,2.778,0,0,0-1.949.851,1.564,1.564,0,0,0-1.551-.851,2.769,2.769,0,0,0-1.729.722.63.63,0,0,0-.7-.568h-.215a.643.643,0,0,0-.707.707v5.059a.638.638,0,0,0,.707.707h.322a.638.638,0,0,0,.707-.707V25.037a1.691,1.691,0,0,1,1.138-.614c.274,0,.59.1.59.853v3.536a.638.638,0,0,0,.707.707h.334a.638.638,0,0,0,.707-.707V24.99a1.559,1.559,0,0,1,1.09-.567c.42,0,.626.245.626.746v3.643a.637.637,0,0,0,.706.707h.322a.638.638,0,0,0,.707-.707V24.978c0-1.384-.61-2.087-1.814-2.087",
          transform: "translate(11.153 11.06)",
          fill: __props.color
        }, null, 8, _hoisted_7),
        _createElementVNode("path", {
          d: "M32.884,24.932h-.963c.09-.07.194-.141.306-.215a2.328,2.328,0,0,0,1.323-1.879,1.551,1.551,0,0,0-1.738-1.6A1.807,1.807,0,0,0,30.029,22.3a.654.654,0,0,0-.03.574.578.578,0,0,0,.421.288l.179.039a.584.584,0,0,0,.743-.332c.018-.03.036-.062.068-.11a.3.3,0,0,1,.3-.148c.217,0,.291.073.291.282,0,.289-.288.507-.762.829-.165.111-.334.225-.494.354a1.9,1.9,0,0,0-.879,1.455v.255a.5.5,0,0,0,.544.544h2.477a.614.614,0,0,0,.687-.6v-.209a.61.61,0,0,0-.687-.592",
          transform: "translate(14.427 10.263)",
          fill: __props.color
        }, null, 8, _hoisted_8),
        _createElementVNode("path", {
          d: "M16.222,24.183a2.716,2.716,0,0,0-1.58.452l.122-1.657h2.993c.47,0,.709-.1.709-.672V22.07a.609.609,0,0,0-.709-.672H14.043a.684.684,0,0,0-.743.7l-.261,3.488c-.024.31-.049.663.5.788l.395.082c.4.083.587-.085.862-.341l.068-.064a1.283,1.283,0,0,1,.945-.353A1.326,1.326,0,0,1,17.2,27.2,1.442,1.442,0,0,1,15.7,28.825a1.412,1.412,0,0,1-1.241-.529l-.028-.033c-.2-.249-.411-.509-.884-.254l-.4.215a.53.53,0,0,0-.191.923,3.183,3.183,0,0,0,2.8,1.237,3.052,3.052,0,0,0,3.315-3.2,2.713,2.713,0,0,0-2.839-3",
          transform: "translate(6.162 10.338)",
          fill: __props.color
        }, null, 8, _hoisted_9),
        _createElementVNode("path", {
          d: "M20.54,30.431c2.038,0,3.159-1.6,3.159-4.518,0-2.974-1.121-4.611-3.159-4.611s-3.161,1.637-3.161,4.611c0,2.914,1.123,4.518,3.161,4.518m0-7.607c.877,0,1.3,1.011,1.3,3.089,0,2.008-.427,2.984-1.3,2.984s-1.3-.976-1.3-2.984c0-2.078.426-3.089,1.3-3.089",
          transform: "translate(8.396 10.292)",
          fill: __props.color
        }, null, 8, _hoisted_10)
      ])
    ])
  ]))
}
}

})